var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48769 6.72922L1.39031 11.8266C1.29134 11.9256 1.18009 11.9751 1.05658 11.9751C0.933062 11.9751 0.813505 11.9173 0.697907 11.8017C0.58231 11.6861 0.524511 11.5665 0.524511 11.443C0.524511 11.3195 0.58231 11.1999 0.697907 11.0843L5.77035 5.98694L0.672967 0.890736C0.557369 0.790974 0.503925 0.675376 0.512634 0.543943C0.520552 0.411718 0.58231 0.287807 0.697907 0.172209C0.813505 0.057403 0.933062 0 1.05658 0C1.18009 0 1.29965 0.057403 1.41525 0.172209L6.48769 5.29454L11.5851 0.19715C11.6841 0.0981788 11.7993 0.0447344 11.9307 0.0368167C12.0629 0.0281073 12.1868 0.0815517 12.3024 0.19715C12.418 0.312747 12.4758 0.432304 12.4758 0.555819C12.4758 0.679335 12.418 0.798891 12.3024 0.914489L7.20503 6.01188L12.3274 11.1093C12.4263 11.2249 12.4798 11.3401 12.4877 11.4549C12.4956 11.5705 12.4422 11.6861 12.3274 11.8017C12.1951 11.9339 12.0673 12 11.9438 12C11.8202 12 11.7007 11.9339 11.5851 11.8017L6.48769 6.72922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear-icon.67861a3ead426279ae0f840b4c9aeb6f.svg";
export { ForwardRef as ReactComponent };